import AssetView from './AssetView.container';

export default AssetView;
